/** @format */

import { ColumnFilter } from "./ColumnFilter";
import React from "react";
import {
  capitalize,
  extractErrorMessage,
  replaceUnderscoresWithSpaces,
} from "utils/strings";
import { useBulkMarkAttendanceMutation } from "store/services/providerAPI";
import { ReactComponent as CancelIcon } from "images/svg/x.svg";
import { ReactComponent as MarkIcon } from "images/svg/mark.svg";
import { ReactComponent as Confirm } from "images/svg/confirm.svg";
import { ReactComponent as UnMarkIcon } from "images/svg/unmark.svg";
import Swal from "sweetalert2";

export const ATTENDANCE_COLUMNS = (
  selectedIds,
  handleRowSelection,
  cohort,
  schedule,
  program,
  refetch
) => [
  {
    Header: "",
    accessor: "id",
    disableSortBy: true,
    Cell: ({ row }) => {
      return (
        <input
          type="checkbox"
          checked={selectedIds.includes(row?.original?.id) ? true : false}
          onChange={() => handleRowSelection(row?.original?.id)}
        />
      );
    },
  },
  {
    Header: "Name",
    accessor: "first_name",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: ({ cell }) => {
      return `${capitalize(cell?.row?.original?.first_name)} ${capitalize(
        cell?.row?.original?.last_name
      )}`;
    },
  },

  {
    Header: "Fellow ID",
    accessor: "fellow_id",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: ({ cell }) => {
      return `${capitalize(cell?.row?.original?.fellow_id)}`;
    },
  },

  {
    Header: "Attendance Marked",
    accessor: "attendancess",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: ({ cell }) => {
      const attendances = cell?.row?.original?.attendances ?? [];
      return attendances.length > 0 ? `Marked` : "Not Marked";
    },
  },

  {
    Header: "Attendance Confirmed",
    accessor: "attendances",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: ({ cell }) => {
      const attendances = cell?.row?.original?.attendances ?? [];
      if (attendances.length > 0) {
        return attendances[0]?.fellow_confirmed ? (
          <p className="badge-status confirmed">
            <Confirm /> <span> Confirmed</span>
          </p>
        ) : (
          <p className="badge-status not-confirmed">
            <CancelIcon />
            <span>Not Confirmed</span>
          </p>
        );
      }
      return (
        <p className="badge-status not-confirmed">
          <CancelIcon />
          <span>Not Confirmed</span>
        </p>
      );
    },
  },

  {
    Header: "Cohort",
    accessor: "cohort",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: () => {
      return cohort?.label;
    },
  },

  {
    Header: "Actions",
    accessor: "last_name",
    Filter: ColumnFilter,
    disableFilters: true,
    sortable: false,
    Cell: ({ cell }) => {
      const [bulkMarkAttendance, { isLoading }] =
        useBulkMarkAttendanceMutation();
      const attendances = cell?.row?.original?.attendances ?? [];
      const name =
        cell?.row?.original?.first_name + " " + cell?.row?.original?.last_name;

      const handleSubmit = async () => {
        await bulkMarkAttendance({
          schedule_id: schedule?.id,
          status: "present",
          fellows: [cell?.row?.original?.id],
          confirmation_page_link:
            "https://app.3mtt.training/fellow/confirm-attendance",
          program,
        })
          .unwrap()
          .then((data) => {
            Swal.fire({
              title: "Success",
              text: `${schedule?.label} Attendance has now been completed for this fellow - ${name}`,
              icon: "success",
              showCloseButton: true,
              customClass: {
                icon: "no-border",
              },
              confirmButtonText: "Ok",
            });
            refetch();
          })
          .catch((error) => {
            const formattedError = extractErrorMessage(error);
            Swal.fire({
              title:
                replaceUnderscoresWithSpaces(error?.data?.code) ||
                "Error Occured",
              text: formattedError,
              iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
              showCloseButton: true,
              customClass: {
                icon: "no-border",
              },
              confirmButtonText: "Try Again",
            });
          });
      };



      return (
        <div className="d-flex justify-content-center align-items-center">
          { isLoading ?  <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              /> :  attendances.length > 0 ? (
            <div className="mark-box">
              <p>Marked</p>
              <button>
                <MarkIcon />
              </button>
            </div>
          ) : (
            <div className="mark-box">
              <p>Mark</p>
              <button
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: `You are about to mark ${name} as present`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, mark it!",
                    cancelButtonText: "No, cancel!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleSubmit();
                    }
                  });
                }}
              >
                <UnMarkIcon />
              </button>
            </div>
          )}
        </div>
      );
    },
  },
];
